module.exports = __webpack_public_path__ + "src/images/products/prep/25_Vintage Two Pocket Shirt.png";